enum UserRoles {
  'USER' = 'User',
  'ADMIN' = 'Admin',
}

interface UserDeviceInfo {
  ios?: {
    model: string;
    version: string;
  }
  android?: {
    model: string;
    version: string;
  }
}

enum StateAuth {
  LOADING = 'LOADING',
  CONNECTED = 'CONNECTED',
  NOT_CONNECTED = 'NOT_CONNECTED',
}

// Podiums of the weekly rankings.
interface RankMedals {
  top1: number;
  top2: number;
  top3: number;
}

interface User {
  id: string;
  avatar: string;
  bio: string;
  dateOfBirth: string;
  isConnected: StateAuth;
  language: string;
  username: string;
  email: string;
  phone: string;
  connectedAt?: number;
  connectedWith?: string;
  createdAt?: number;
  deletedAt?: number;
  deviceInfo?: UserDeviceInfo;
  os: string;
  twitter?: string;
  timezone: string;
  role?: string;
  feedPreference?: string;
  isFollowed?: boolean;
  // recruit, soldier, veteran, elite, legend
  rank?: string;
  // Points of the weekly tops, they give the rank.
  rankPoints?: number;
  // Number of weeks at the top 1, 2 and 3 of a game.
  rankMedals?: RankMedals;
  fcmPermissionStatus?: string;
  versionApple?: string;
  versionAndroid?: string;
}

interface UserStat {
  userEnrolled: number;
  userEnrolledByDay: number;
  userEnrolledByWeek: number;
}

export { UserRoles };

export type { RankMedals, User, UserStat };
